module.exports = "/images/vendor/flag-icon-css/flags/1x1/tk.svg?7aaccddb93a504f69855f07491550439";